/** 文献标注首页 */
<template>
  <div class="module-index annotation-index">
    <div class="aside-box">
      <div class="fit">
        <AsideFilter
          ref="asideFilterRef"
          :filterData="filterData"
          @update-filter="handleUpdateAsideFilter"
        />
      </div>
    </div>
    <div class="main-box">
      <div class="header-box">
        <HeaderBar :selectList="selectDataList" @refresh="refresh" />
      </div>
      <div class="content-box list-box">
        <AnnotationList
          ref="annotationListRef"
          :filterData="asideFilterData"
          @select-change="handleSelectChange"
          @update-filter="handleUpdateFilter"
          @refresh="refreshFilter"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted } from "vue";
import HeaderBar from "./components/HeaderBar.vue";
import AsideFilter from "./components/AsideFilter.vue";
import AnnotationList from "./components/AnnotationList.vue";

//表格选择改变
const selectDataList = ref([]);
const handleSelectChange = (selectList) => {
  selectDataList.value = selectList;
};
//筛选条件改变
const filterData = ref(null);
const handleUpdateFilter = (data) => {
  filterData.value = data;
};
const asideFilterData = ref(null);
const handleUpdateAsideFilter = (data) => {
  asideFilterData.value = data;
};
//刷新列表
const annotationListRef = ref(null);
const asideFilterRef = ref(null);
const refresh = () => {
  nextTick(() => {
    asideFilterRef.value.getData();
    asideFilterRef.value.getTagData();
    annotationListRef.value.getData();
  });
};
const refreshFilter = () => {
  nextTick(() => {
    asideFilterRef.value.getData();
    asideFilterRef.value.getTagData();
  });
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/module/module-index.scss";
</style>
